<template>
  <div class="exit">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Exit</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Exit</li>
                  <li
                    class="breadcrumb-item active"
                    v-if="displayStatusR === true"
                  >
                    Resignations
                  </li>
                  <li
                    class="breadcrumb-item active"
                    v-if="displayStatusRT === true"
                  >
                    Retirements
                  </li>
                  <li
                    class="breadcrumb-item active"
                    v-if="displayStatusT === true"
                  >
                    Terminations
                  </li>
                </ul>
              </div>
              <div class="col-md-3 float-right ml-auto">
                <div class="row">
                  <button
                    class="btn btn-primary dropdown-toggle m-1"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Exit Option
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a class="dropdown-item" @click="getEmployeeResignations"
                      >Resignations</a
                    >
                    <a class="dropdown-item" @click="getEmployeeRetirements"
                      >Retirements</a
                    >
                    <a class="dropdown-item" @click="getEmployeeTerminations"
                      >Terminations</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--- Resignation Datatable-->
          <div class="row" v-if="displayStatusR === true">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headersR"
                  :items="resignations"
                  sort-by="firstName"
                  class="elevation-1"
                >
                  <template v-slot:[`item.resignationDate`]="{ item }">
                    {{
                      item.resignationDate
                        ? new Date(item.resignationDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.noticeDate`]="{ item }">
                    {{
                      item.noticeDate
                        ? new Date(item.noticeDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <a
                      class="btn btn-primary"
                      aria-expanded="false"
                      @click="setexit(item, 1)"
                    >
                      Exit
                    </a>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <a @click="setDetailexit(item)" class="avatar">
                        <img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></a>

                      <a @click="setDetailexit(item)">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</a>
                    </h2>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && !item.exitInterview"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.exitInterview"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-info"></i> Pending
                      Interview
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->

          <!--- Resignation Datatable-->
          <div class="row" v-if="displayStatusRT === true">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headersRT"
                  :items="retirements"
                  sort-by="firstName"
                  class="elevation-1"
                >
                  <template v-slot:[`item.retirementDate`]="{ item }">
                    {{
                      item.retirementDate
                        ? new Date(item.retirementDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.noticeDate`]="{ item }">
                    {{
                      item.noticeDate
                        ? new Date(item.noticeDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <a
                      class="btn btn-primary"
                      aria-expanded="false"
                      @click="setexit(item, 1)"
                    >
                      Exit
                    </a>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <a @click="setDetailexit(item)" class="avatar">
                        <img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></a>

                      <a @click="setDetailexit(item)">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</a>
                    </h2>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && !item.exitInterview"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.exitInterview"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-info"></i> Pending
                      Interview
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->

          <!--- Termination Datatable-->
          <div class="row" v-if="displayStatusT === true">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headersT"
                  :items="terminations"
                  sort-by="firstName"
                  class="elevation-1"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    {{
                      item.date ? new Date(item.date).toLocaleDateString() : ""
                    }}
                  </template>
                  <template v-slot:[`item.noticeDate`]="{ item }">
                    {{
                      item.noticeDate
                        ? new Date(item.noticeDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <a
                      class="btn btn-primary"
                      aria-expanded="false"
                      @click="setexit(item, 2)"
                    >
                      Exit
                    </a>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <a class="avatar">
                        <img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></a>

                      <a>{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</a>
                    </h2>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && !item.exitInterview"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.exitInterview"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-info"></i> Pending
                      Interview
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->
        <!-- Delete exit Modal -->
        <v-dialog v-model="dialogExit" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button
                  Category="button"
                  class="close"
                  id="close"
                  @click="closeExit"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Exit employee</h3>
                <p>Are you sure want to exit this employee?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="exitEmployee"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Exit</a
                    >
                  </div>
                  <div class="col-6">
                    <a @click="closeExit" class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete exit Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialogExit: false,
      media: "data:image/jpeg;base64,",
      headersR: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },

        { text: "Reason", value: "reason" },
        { text: "Notice Date", value: "noticeDate" },
        { text: "Date", value: "resignationDate" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      headersRT: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },

        { text: "Reason", value: "reason" },
        { text: "Notice Date", value: "noticeDate" },
        { text: "Date", value: "retirementDate" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      headersT: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },

        { text: "Reason", value: "reason" },
        { text: "Notice Date", value: "noticeDate" },
        { text: "Date", value: "date" },
        // { text: 'Status', value: 'stat'},
        { text: "Action", value: "actions", sortable: false }
      ],
      name: "",
      employeeId: "",
      reason: "",
      noticeDate: "",
      interviewDate: "",
      exitDate: "",
      exit: {
        employee: {},
        exitInterview: {}
      },
      type: 0,
      exits: [],
      employee: [],
      loading: false,
      error: "",
      employees: [],
      resignations: [],
      retirements: [],
      terminations: [],
      displayStatusR: false,
      displayStatusT: false,
      displayStatusRT: false,
      submitted: false,
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue
    };
  },

  watch: {
    dialogExit(val) {
      val || this.closeExit();
    }
  },
  methods: {
    // getEmployees(id) {
    //   employeeService.getEmployees(id).then(
    //     (model) => {
    //       console.log(model);
    //       this.employees = model;
    //     },
    //     (error) => {
    //       error = error;
    //     }
    //   );
    // },

    getEmployees() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getEmployees(companyId).then(
        model => {
          this.employees = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getEmployeeexits() {
      const companyId = this.company.id;
      employeeService.getEmployeeexits(companyId).then(
        model => {
          // console.log(model)
          this.exits = model;
        },
        error => {
          error = error;
        }
      );
    },
    closeExit() {
      this.dialogExit = false;
    },
    setexit(model, type) {
      this.exit = model;
      this.type = type;
      this.dialogExit = true;
    },

    getEmployeeResignations() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployeeResignations(unit.id).then(
        model => {
          console.log(model);
          const b = model.filter(a => a.status === 1);
          console.log(b);
          // this.resignations = model;
          this.resignations = b;
          console.log(`this.exits`, this.exits);
          this.displayStatusR = true;
          this.displayStatusT = false;
          this.displayStatusRT = false;
        },
        error => {
          error = error;
        }
      );
    },

    getEmployeeRetirements() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployeeRetirements(unit.id).then(
        model => {
          console.log(model);
          const b = model.filter(a => a.status === 1);
          console.log(b);
          // this.resignations = model;
          this.retirements = b;
          console.log(`this.exits`, this.exits);
          this.displayStatusR = false;
          this.displayStatusT = false;
          this.displayStatusRT = true;
        },
        error => {
          error = error;
        }
      );
    },

    getEmployeeTerminations() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployeeTerminations(unit.id).then(
        model => {
          this.terminations = model;
          this.exits = model;
          this.displayStatusT = true;
          this.displayStatusR = false;
          this.displayStatusRT = false;
          console.log(`this.terminations`, this.terminations);
        },
        error => {
          error = error;
        }
      );
    },

    exitEmployee() {
      const id = this.exit.id;
      const employeeId = this.exit.employee.id;
      const type = this.type;
      // console.log(this.exit)
      employeeService.exitEmployee(id, employeeId, type).then(id => {
        if (type == 1) {
          this.getEmployeeResignations();
        } else {
          this.getEmployeeTerminations();
        }
        this.closeExit();
      });
    }
  },

  mounted() {
    this.getEmployees();
    this.getEmployeeResignations();
    this.getEmployeeTerminations();
    this.getEmployeeRetirements();
    // this.getEmployeeexits()
    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeeexits(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "exit"
};
</script>



// WEBPACK FOOTER //
// src/components/exit/exit.vue